(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knowledge-article"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aurien-knowledge')) {
  customElements.define('aurien-knowledge', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.contents = this.querySelector('.ak-contents details');
      this.mobile = matchMedia('(max-width:999px)');
      const fallback = this.querySelector('.ak-fallback');
      if (fallback && this.contents) {
        const nav = this.contents.querySelector('nav');
        nav.replaceChildren();
        fallback.querySelectorAll('h2').forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.closest('[id]').id}-heading-${index + 1}`;
          const a = document.createElement('a'); a.href = `#${heading.id}`; a.textContent = heading.textContent; nav.append(a);
        });
        if (!nav.children.length) this.querySelector('.ak-contents').hidden = true;
      }
      const setMode = () => { if (this.contents) this.contents.open = !this.mobile.matches; };
      setMode(); this.mobile.addEventListener('change', setMode, {signal});
      this.contents?.addEventListener('toggle', () => { if (!this.mobile.matches && !this.contents.open) this.contents.open = true; }, {signal});
      this.links = [...this.querySelectorAll('.ak-contents nav a')];
      const update = () => {
        let current = this.links[0];
        const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
        for (const link of this.links) { const target = document.getElementById(link.hash.slice(1)); if (target && target.getBoundingClientRect().top <= offset + 100) current = link; }
        this.links.forEach(link => { if (link === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
        this.frame = null;
      };
      window.addEventListener('scroll', () => { if (!this.frame) this.frame = requestAnimationFrame(update); }, {signal, passive:true});
      window.addEventListener('resize', update, {signal}); update();
      const openSource = target => { const disclosure = target?.closest('.ak-source-disclosure'); if (disclosure) disclosure.open = true; };
      this.addEventListener('click', event => {
        const link = event.target.closest('a'); if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        const url = new URL(link.href, location.href); if (!url.hash || (url.pathname !== location.pathname && url.pathname !== this.dataset.articlePath)) return;
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1))); if (!target) return;
        event.preventDefault(); openSource(target);
        if (this.mobile.matches && this.contents?.contains(link)) this.contents.open = false;
        history.pushState(null, '', url.hash);
        requestAnimationFrame(() => target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
      }, {signal});
      const reveal = () => {
        if (!location.hash) return;
        let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id); if (target?.closest('.ak-source-disclosure')) { openSource(target); requestAnimationFrame(() => target.scrollIntoView()); }
      };
      window.addEventListener('hashchange', reveal, {signal}); reveal();
    }
    disconnectedCallback() { this.controller?.abort(); if (this.frame) cancelAnimationFrame(this.frame); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
